import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { writeRsCmdSettings, getDmImei } from '../../../../redux/actions';
import './BtnStartStop.css';

export default function BtnStartStop ({pumpNumber}) {

    const parameter = useSelector((state) => state.dmimei?.data[0]);
    const dispatch = useDispatch();
    const PUMP_COMMANDS = [0, 1, 2, 4, 8]; //число в cmd соответствующее НА. 
    const alertText = parameter?.typeRsDevice_name==='PLC' ? 
    (`Насоса №${pumpNumber}`) : 'ПЧ';

    function hendelClickStart() {
        let num;
        let inputvalue;
       

        if (parameter?.typeRsDevice_name==='PLC') {
            num=11;
            inputvalue=PUMP_COMMANDS[pumpNumber];
        }
        if (parameter?.typeRsDevice_name==='PCH_Instart' ||
            parameter?.typeRsDevice_name==='PCH_ESQ' || 
            parameter?.typeRsDevice_name==='PCH_ATV') {
            num=13;
            inputvalue=1;
        }
        dispatch(writeRsCmdSettings(parameter?.imei, inputvalue, num))
        .then(() => dispatch(getDmImei(parameter?.imei)))
        .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
        alert (`Команда на запуск ${alertText} отправлена`);
    }

    function hendelClickStop() {
        let num;
        let inputvalue;
        if (parameter?.typeRsDevice_name==='PLC') {
            num=12;
            inputvalue=PUMP_COMMANDS[pumpNumber];
        }
        if (parameter?.typeRsDevice_name==='PCH_Instart' ||
            parameter?.typeRsDevice_name==='PCH_ATV') {
                num=14;
                inputvalue=6;
            }

        if (parameter?.typeRsDevice_name==='PCH_ESQ') {
            num=15;
            inputvalue=5;
        }

        dispatch(writeRsCmdSettings(parameter?.imei, inputvalue, num))
        .then(() => dispatch(getDmImei(parameter?.imei)))
        .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
        alert (`Команда на останов ${alertText} отправлена`);
    }

    return(
        <div className="BtnStartStop">
            <button className='BtnPumpStart' onClick={hendelClickStart}>Пуск</button>
            <button className='BtnPumpStop' onClick={hendelClickStop}>Стоп</button>
        </div>
    )
}